import React, { useState } from "react";
import { getClinicId } from "../../../../utils/config";
import DisciplineSelector from "./manageSlotsParts/components/DisciplineSelector";
import PractitionerSelector from "./manageSlotsParts/components/PractitionerSelector";
import DateSelector from "./manageSlotsParts/components/DateSelector";
import SlotGrid from "./manageSlotsParts/components/SlotGrid";
import "./ManageSlots.css";

const ManageSlots = ({ user }) => {
  const clinicId = getClinicId(user);

  const [selectedDiscipline, setSelectedDiscipline] = useState(null);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleResetWorkflow = () => {
    setSelectedDiscipline(null);
    setSelectedPractitioner(null);
    setSelectedDate(null);
  };

  return (
    <div className="main-panel-manage_manage_slots_settings">
      <div className="manage-slots-wrapper_manage_slots_settings">
        <h2>Manage Slot Availability</h2>

        <DisciplineSelector
          clinicId={clinicId}
          selectedDiscipline={selectedDiscipline}
          setSelectedDiscipline={setSelectedDiscipline}
          setSelectedPractitioner={setSelectedPractitioner}
          setSelectedDate={setSelectedDate}
        />

        <PractitionerSelector
          clinicId={clinicId}
          selectedDiscipline={selectedDiscipline}
          selectedPractitioner={selectedPractitioner}
          setSelectedPractitioner={setSelectedPractitioner}
          setSelectedDate={setSelectedDate}
        />

        {selectedDiscipline && selectedPractitioner && (
          <DateSelector
            clinicId={clinicId}
            practitionerId={selectedPractitioner}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        )}

        {selectedDiscipline && selectedPractitioner && selectedDate && (
          <SlotGrid
            clinicId={clinicId}
            practitionerId={selectedPractitioner}
            selectedDate={selectedDate}
            onResetSelections={handleResetWorkflow}
          />
        )}
      </div>
    </div>
  );
};

export default ManageSlots;
